export default "<div class=\"alert\" role=\"alert\">\r\n    <span>{{ message }}</span>\r\n  </div>"